import { useMemo } from "react";
import {
    RuleConditionType,
    TransactionRule,
} from "@common/types/transactionRule";
import { Entity } from "@common/types/entity";
import { useEntities } from "./useEntities";

export function useRuleEntities(
    rule: Pick<TransactionRule, "conditions">,
): Entity[] {
    const allEntities = useEntities();

    return useMemo(() => {
        const entityCondition = rule.conditions.find(
            (c) => c.conditionType === RuleConditionType.ENTITY,
        );
        if (!entityCondition) {
            return [];
        }
        const ids = (
            Array.isArray(entityCondition.value)
                ? entityCondition.value
                : [entityCondition.value]
        ) as number[];
        return allEntities.filter((e) => ids.includes(e.id));
    }, [rule.conditions, allEntities]);
}
